import type { ReactElement } from 'react';
import { controlReceiptLabel, type ControlReceiptView } from '../lib/control-receipt';

/** The words for one pressed control. The action name keeps the line on that press. */
export function ControlReceiptNote({
  view, action,
}: {
  readonly view: ControlReceiptView;
  readonly action?: string;
}): ReactElement {
  const phase = view.done ? 'done'
    : view.refusedReason !== null ? 'refused'
      : view.acknowledged ? 'acknowledged'
        : 'sent';
  return (
    <span className="control-receipt" role="status" data-control-receipt={phase}
      {...(action === undefined || action.trim() === '' ? {} : { 'data-control-action': action })}>
      {controlReceiptLabel(view, action)}
    </span>
  );
}
